<template>
  <div
    :class="['scene', 'container-1440', this.scene]"
    v-if="this.$store.getters.scene == scene"
  >
    <div :class="['scene', this.scene]">
      <div class="grid footer-fixed-spacer">
        <div class="six top-space">
          <div class="sticky-wrapper" id="sticky">
            <DetailsPictures />
          </div>
        </div>

        <div class="six more-space relative">
          <div class="scroll-container">
            <RecieptsCount />
            <RatingStars />
            <IndividualSupplement
              :name="this.$store.getters.name"
              :total="this.displayPrice().toFixed(2)"
              :currencySymbol="this.$store.getters.currencySymbol"
            ></IndividualSupplement>

            <!-- <CapsulaInfo
      :text-info-producer="$t('scene_summary.text_info_producer')"
      :text-x-capsule="$t('scene_summary.text_x_capsule')"
      :text-last-x-days="$t('scene_summary.text_last_x_days')"
      :text-ingredient-count="$t('scene_summary.text_ingredient_count')"
      :text-pay-per-day="$t('scene_summary.text_pay_per_day')"
      :personalMix="this.$store.getters.personalMix"
      :renderTrigger="this.$store.getters.capsulaFill"
    >
    </CapsulaInfo> -->
            <!-- <p v-if="orders.length == 0">{{ textNoOrder }}</p> -->
            <div class="payment-options">
              <h2 class="font-roc-grotesk-medium payment-options-header">
                {{ $t("scene_productdetails.paymentOption") }}
              </h2>
              <div class="buttons-group">
                <button
                  type="button"
                  class="font-roc-grotesk-medium"
                  :class="{
                    'btn-active': this.$store.getters.monthly,
                    'btn-inactive': !this.$store.getters.monthly,
                    active: this.$store.getters.monthly,
                  }"
                  @click="setMonthly(true)"
                >
                  {{ $t("scene_productdetails.buttonMonthly") }}
                </button>

                <button
                  type="button"
                  class="font-roc-grotesk-medium"
                  :class="{
                    'btn-active': !this.$store.getters.monthly,
                    'btn-inactive': this.$store.getters.monthly,
                    active: this.$store.getters.monthly,
                  }"
                  @click="setMonthly(false)"
                >
                  {{ $t("scene_productdetails.buttonOneTime") }}
                </button>
              </div>

              <div class="payment-details-label font-roc-grotesk-light">
                {{ $t("scene_productdetails.paymentDetails") }}
              </div>
              <p
                v-if="this.$store.getters.monthly"
                class="payment-details-text font-roc-grotesk-light"
              >
                {{
                  $t("scene_productdetails.moreRates")
                    .replace("[#NUMBER#]", this.ratePrice())
                    .replace("[#VALUE#]", this.monthlyPrice())
                    .replace("[#CURRENCY#]", this.$store.getters.currencySymbol)
                }}
              </p>
              <p v-else class="payment-details-text font-roc-grotesk-light">
                {{
                  $t("scene_productdetails.oneRate")
                    .replace("[#VALUE#]", this.totalPrice().toFixed(2))
                    .replace("[#CURRENCY#]", this.$store.getters.currencySymbol)
                }}
              </p>

              <h2 class="font-roc-grotesk-medium payment-options-header">
                {{ $t("scene_productdetails.reorder") }}
              </h2>
              <div class="buttons-group reorder-buttons-group">
                <button
                  type="button"
                  class="font-roc-grotesk-medium btn-discount"
                  :class="{
                    'btn-active': this.$store.getters.reorder,
                    'btn-inactive': !this.$store.getters.reorder,
                    active: this.$store.getters.monthly,
                  }"
                  @click="setReorder(true)"
                >
                  {{ $t("scene_productdetails.reorderButton") }}
                </button>
                <button
                  type="button"
                  class="font-roc-grotesk-medium"
                  :class="{
                    'btn-active': !this.$store.getters.reorder,
                    'btn-inactive': this.$store.getters.reorder,
                    active: this.$store.getters.monthly,
                  }"
                  @click="setReorder(false)"
                >
                  {{ $t("scene_productdetails.noReorder") }}
                </button>
              </div>
              <p
                v-if="this.$store.getters.reorder"
                class="reorder-details-text font-roc-grotesk-light"
              >
                {{
                  $t("scene_productdetails.textReorder").replace(
                    "[#NUMBER#]",
                    this.everyXMonths()
                  )
                }}
              </p>
              <p
                v-if="!this.$store.getters.reorder"
                class="reorder-details-text font-roc-grotesk-light"
              >
                {{ $t("scene_productdetails.textNoReorder") }}
              </p>

              <div v-if="showBloodTestOption()" class="checkbox-group">
                <input
                  type="checkbox"
                  id="blood-test"
                  class="checkbox-blood-test"
                  :modelValue="this.$store.getters.isBloodTestChecked"
                  @change="setBloodTest($event.target.checked)"
                />
                <label for="blood-test">
                  {{ $t("scene_productdetails.bloodTest") }}
                </label>
                <img
                  src="/assets/information.png"
                  class="info-icon"
                  @click="openBloodTest"
                />
              </div>

              <div class="picture-div">
                <template v-if="circulyPayment">
                  <img src="/pay-options/mc.svg" class="picture-test" />
                  <img src="/pay-options/vs.svg" class="picture-test" />
                  <img src="/pay-options/pp.svg" class="picture-test" />
                </template>
                <template v-else>
                  <img src="/pay-options/ae.svg" class="picture-test" />
                  <img src="/pay-options/ap.svg" class="picture-test" />
                  <img src="/pay-options/gp.svg" class="picture-test" />
                  <img src="/pay-options/me.svg" class="picture-test" />
                  <img src="/pay-options/mc.svg" class="picture-test" />
                  <img src="/pay-options/pp.svg" class="picture-test" />
                  <img src="/pay-options/sp.svg" class="picture-test" />
                  <img src="/pay-options/vs.svg" class="picture-test" />
                  <img src="/pay-options/tw.svg" class="picture-test" />
                </template>
              </div>
            </div>
            <CheckoutButton :button-checkout="buttonCheckout" :i18n="$i18n" />
            <Accordion
              v-for="(order, index) in orders"
              :key="order.id"
              :defaultOpen="index === 0"
            >
              <template #trigger="{ isOpen }">
                <div class="order-header cursor">
                  <div class="mix-headline font-roc-grotesk-medium">
                    {{ order.name }} {{ headlineMix }}
                  </div>
                  <div class="order-toggle">
                    <img src="/assets/arrow-up.svg" v-if="isOpen" />
                    <img src="/assets/arrow-down.svg" v-if="!isOpen" />
                  </div>
                </div>
              </template>
              <template #content>
                <div class="order-content font-roc-grotesk-light">
                  <CapsulaInfo
                    :text-info-producer="$t('scene_summary.text_info_producer')"
                    :text-x-capsule="$t('scene_summary.text_x_capsule')"
                    :text-last-x-days="$t('scene_summary.text_last_x_days')"
                    :text-ingredient-count="
                      $t('scene_summary.text_ingredient_count')
                    "
                    :text-pay-per-day="$t('scene_summary.text_pay_per_day')"
                    :personalMix="this.$store.getters.personalMix"
                    :renderTrigger="this.$store.getters.capsulaFill"
                  >
                  </CapsulaInfo>
                  <!-- <p class="ing-text margin-top">
                    <b>{{ textIngredients }}</b>
                    {{
                      this.getIngredientsString(
                        order.getPersonalMixSortedByIngredientConcentrationMg()
                      )
                    }}
                  </p> -->
                </div></template
              >
            </Accordion>
            <Accordion>
              <template #trigger="{ isOpen }">
                <div class="order-header cursor">
                  <div class="mix-headline font-roc-grotesk-medium">
                    {{ $t("scene_productdetails.ingredients2") }}
                  </div>
                  <div class="order-toggle">
                    <img src="/assets/arrow-up.svg" v-if="isOpen" />
                    <img src="/assets/arrow-down.svg" v-if="!isOpen" />
                  </div>
                </div>
              </template>
              <template #content>
                <IngredientsList
                  :headline="textIngInYourMix + ':'"
                  :ingredients="this.$store.getters.personalMix"
                  :text-button-show-all-ingredients="
                    $t('scene_productdetails.show_all_ingredients')
                  "
                >
                </IngredientsList>
              </template>
            </Accordion>
            <Accordion v-for="order in orders" :key="order.id">
              <template #trigger="{ isOpen }">
                <div class="order-header cursor">
                  <div class="mix-headline font-roc-grotesk-medium">
                    {{ $t("scene_productdetails.reciept") }}
                  </div>
                  <div class="order-toggle">
                    <img src="/assets/arrow-up.svg" v-if="isOpen" />
                    <img src="/assets/arrow-down.svg" v-if="!isOpen" />
                  </div>
                </div>
              </template>
              <template #content>
                <div
                  class="order-content font-roc-grotesk-light"
                  v-if="order.isVisible"
                >
                  <!-- <CapsulaInfo
                    :text-info-producer="$t('scene_summary.text_info_producer')"
                    :text-x-capsule="$t('scene_summary.text_x_capsule')"
                    :text-last-x-days="$t('scene_summary.text_last_x_days')"
                    :text-ingredient-count="
                      $t('scene_summary.text_ingredient_count')
                    "
                    :text-pay-per-day="$t('scene_summary.text_pay_per_day')"
                    :personalMix="this.$store.getters.personalMix"
                    :renderTrigger="this.$store.getters.capsulaFill"
                  >
                  </CapsulaInfo> -->
                  <p class="ing-text margin-top">
                    <b>{{ textIngredients }}</b>
                    {{
                      this.getIngredientsString(
                        order.getPersonalMixSortedByIngredientConcentrationMg()
                      )
                    }}
                  </p>
                  <table>
                    <tr>
                      <td
                        class="padding-top-bottom border-bottom border-right font-roc-grotesk-medium"
                      >
                        {{ textColumn }}
                      </td>
                      <td
                        class="padding-top-bottom border-bottom text-center border-right font-roc-grotesk-medium"
                      >
                        {{ textColumnProCapsule }}
                      </td>
                      <td
                        class="padding-top-bottom border-bottom text-center border-right font-roc-grotesk-medium"
                      >
                        {{ textColumnPercentEtd }}
                      </td>
                      <td
                        class="padding-top-bottom border-bottom text-center font-roc-grotesk-medium"
                      >
                        {{ textColumnPrice }}
                      </td>
                      <td class="padding-bottom"></td>
                    </tr>
                    <tr
                      v-for="ing in order.getPersonalMixSorttedByCategory()"
                      :key="ing"
                    >
                      <td class="padding-top-bottom border-bottom border-right">
                        {{ ing.title }}
                        <WarningSign
                          class="warning-sign"
                          :amount="ing.amount"
                          :threshold="ing.warningThreshold"
                          :warning-text="ing.warningHint"
                        ></WarningSign>
                        <InfoLayer
                          type="ingredient"
                          :headline="ing.title"
                          :shortDescription="
                            this.$store.getters.isExpertMode
                              ? ing.shortDescription
                              : ''
                          "
                          :firstImage="ing.firstImage"
                          :bulletpointDescription="
                            this.$store.getters.isExpertMode ||
                            order.healthGoals.length == 0
                              ? ing.bulletpointDescription
                              : ''
                          "
                          :studySituation="ing.studySituation"
                          :origin="ing.origin"
                          :benefits="
                            this.$store.getters.isExpertMode
                              ? null
                              : ing.benefits
                          "
                          :product="ing"
                          :healthGoals="order.healthGoals"
                          :healthPossibleOptions="order.healthPossibleOptions"
                        >
                        </InfoLayer>
                      </td>
                      <td
                        class="padding-top-bottom border-bottom border-right text-center"
                      >
                        {{ ing.amount.toFixed(2) }} {{ ing.unit }}
                      </td>
                      <td
                        class="padding-top-bottom border-bottom border-right text-center"
                      >
                        <span v-if="ing.showRDV">{{ ing.rdv }} %</span>
                      </td>
                      <td class="padding-top-bottom border-bottom text-right">
                        {{ ing.price.toFixed(2) }}
                        {{ this.$store.getters.currencySymbol }}
                      </td>
                      <td class="padding-top-bottom">
                        <img
                          class="margin-left cursor"
                          @click="removeIng(order.id, ing.name)"
                          src="/assets/x.svg"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td
                        class="padding-top-bottom border-bottom-big border-bottom border-right"
                      >
                        {{ textBasePrice }}
                      </td>
                      <td
                        class="padding-top-bottom border-bottom-big border-bottom border-right"
                      ></td>
                      <td
                        class="padding-top-bottom border-bottom-big border-bottom border-right"
                      ></td>
                      <td
                        class="padding-top-bottom border-bottom-big border-bottom text-right"
                      >
                        {{ basePrice }} {{ this.$store.getters.currencySymbol }}
                      </td>
                    </tr>
                    <tr>
                      <td class="padding-top-bottom font-roc-grotesk-medium">
                        {{ textTotalMix }}
                      </td>
                      <td class="padding-top-bottom"></td>
                      <td class="padding-top-bottom"></td>
                      <td
                        class="padding-top-bottom text-right font-roc-grotesk-medium"
                      >
                        {{ this.orderPrice(order.personalMix).toFixed(2) }}
                        {{ this.$store.getters.currencySymbol }}
                      </td>
                    </tr>
                  </table>
                </div>
                <div
                  v-if="order.isVisible && !this.$store.getters.isExpertMode"
                  class="edit-mix"
                  @click="handleEditMix"
                >
                  {{ $t("scene_summary.edit_order") }}
                </div>
                <div v-if="order.isVisible">
                  <div class="order-text2 font-roc-grotesk-light">
                    {{ textRecommendAmount }}
                  </div>

                  <div class="order-text font-roc-grotesk-light">
                    {{ textBuyInfo }}
                  </div>
                </div>
              </template>
            </Accordion>
            <Accordion>
              <template #trigger="{ isOpen }">
                <div class="order-header cursor">
                  <div class="mix-headline font-roc-grotesk-medium">
                    {{ $t("scene_productdetails.abonnement") }}
                  </div>
                  <div class="order-toggle">
                    <img src="/assets/arrow-up.svg" v-if="isOpen" />
                    <img src="/assets/arrow-down.svg" v-if="!isOpen" />
                  </div>
                </div>
              </template>
              <template #content>
                <div class="bullet-item order-text font-roc-grotesk-light">
                  <span class="bullet">-</span>
                  <div v-html="$t('scene_productdetails.text_monthly1')"></div>
                </div>
                <div class="bullet-item order-text font-roc-grotesk-light">
                  <span class="bullet">-</span>
                  <div v-html="$t('scene_productdetails.text_monthly2')"></div>
                </div>
                <div class="bullet-item order-text font-roc-grotesk-light">
                  <span class="bullet">-</span>
                  <div v-html="$t('scene_productdetails.text_monthly3')"></div>
                </div>
                <div class="bullet-item order-text font-roc-grotesk-light">
                  <span class="bullet">-</span>
                  <div v-html="$t('scene_productdetails.text_monthly4')"></div>
                </div>
              </template>
            </Accordion>
            <p v-if="orders.length == 0">{{ textNoOrder }}</p>
            <div
              class="order"
              v-for="(upsellingOrder, index) in this.$store.getters
                .upsellingOrders"
              :key="upsellingOrder.raw_product_id"
            >
              <div class="order-header">
                <div class="upselling-order-headline font-roc-grotesk-regular">
                  {{ upsellingOrder.title }}
                </div>
                <div class="order-header-price">
                  {{ upsellingOrder.min_variant_price }}
                  {{ this.$store.getters.currencySymbol }}
                </div>
                <div class="order-toggle">
                  <img
                    class="margin-left cursor"
                    @click="
                      removeUpselling(
                        upsellingOrder.raw_product_id + '_' + index
                      )
                    "
                    src="/assets/x.svg"
                  />
                </div>
              </div>
            </div>

            <!-- <SuggestedProducts
              :textAddButton="textAddButton"
              :textSuggestedExtras="textSuggestedExtras"
            ></SuggestedProducts> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import calc from "@/helper/calc";
import { getInstallmentsCount } from "@/helper/firmhouse";
import helper from "@/helper/helper";
import IngredientsList from "@/components/IngredientsList.vue";
import IndividualSupplement from "@/components/IndividualSupplement.vue";
import CapsulaInfo from "@/components/CapsulaInfo.vue";
// import SuggestedProducts from "@/components/SuggestedProducts.vue";
import InfoLayer from "@/components/InfoLayer.vue";
import WarningSign from "@/components/WarningSign.vue";
import Accordion from "@/components/Accordion.vue";
import CheckoutButton from "./CheckoutButton.vue";
import DetailsPictures from "./DetailsPictures.vue";
import RatingStars from "@/components/RatingStars.vue";
import RecieptsCount from "@/components/RecieptsCount.vue";

export default {
  props: {
    scene: String,
    textIngInYourMix: String,
    textRecommendFor: String,
    textPersonalizedProduct: String,
    buttonGoToCheckout: String,
    textSuggestedExtras: String,
    textAddButton: String,
    textPricePerMonth: String,
    subline: String,
    buttonAddOrder: String,
    buttonCheckout: String,
    headlineMix: String,
    textIngredients: String,
    textRecommendAmount: String,
    textInfoBag: String,
    textBuyInfo: String,
    textColumn: String,
    textColumnProCapsule: String,
    textColumnPrice: String,
    textColumnPercentEtd: String,
    textTotal: String,
    textTotalMix: String,
    textNoOrder: String,
    textBasePrice: String,
    textConfirm: String,
    textConfirmUpselling: String,
    textIngredients2: String,
    textReciept: String,
    textAbonnement: String,
  },
  computed: {
    insertTextPricePerMonth() {
      return helper.replaceTextWithValueAndCurrency(
        this.$t("scene_productdetails.text_price_per_month"),
        this.currentPricePerMonth().toFixed(2),
        this.$store.getters.currencySymbol
      );
    },
    basePrice() {
      return parseFloat(
        calc.basePrice(
          this.$store.getters.currency,
          this.$store.getters.subscriptionOptions
        )
      ).toFixed(2);
    },
    orders() {
      return this.$store.getters.orders;
    },
    ingredientsCount() {
      return this.$store.getters.personalMix.length;
    },
    circulyPayment() {
      return this.$store.getters.monthly || this.$store.getters.reorder;
    },
    inserTextPricePerMonth() {
      return helper.replaceTextWithValueAndCurrency(
        this.textPricePerMonth,
        this.currentPricePerMonth(),
        this.$store.getters.currencySymbol
      );
    },
  },

  methods: {
    currentPricePerMonth() {
      const pricePerDay = parseFloat(
        calc.orderPrice(
          this.$store.getters.personalMix,
          this.$store.getters.currency,
          this.$store.getters.subscriptionOptions
        ) /
          (calc.capsulasPerMixForCalculation() /
            this.$store.getters.totalCapsulas)
      );

      return pricePerDay * 30;
    },
    openBloodTest() {
      const url = "https://indyvit.com/products/indyvit-all-in-1-bluttest";
      window.open(url, "_blank");
    },

    setMonthly(isMonthly) {
      this.$store.commit("setMonthly", isMonthly);
    },
    setReorder(isReorder) {
      this.$store.commit("setReorder", isReorder);
    },
    setBloodTest(isBloodTest) {
      this.$store.commit("setBloodTestChecked", isBloodTest);
    },
    gradient() {
      let colors = "background: linear-gradient(";
      colors += `12deg, ${this.$store.getters.labelColorHexBottom} 0%, ${this.$store.getters.labelColorHexBottom} 40%, `;
      colors += `#FFFFFF 40%, #FFFFFF 100%`;
      colors += ")";
      return colors;
    },
    inView() {
      // if (this.$store.getters.sceneStepsType === 'alteredOrder' && !this.$store.getters.email || this.$store.getters.email?.indexOf("@") == -1) {
      //   this.showEmailOverlay = true;
      // }
      if (this.$store.getters.sceneStepsType === "alteredOrder") {
        this.$store.dispatch("subscribeMail", "V7L3iL");
      }

      if (document.querySelector("#main").classList.contains("v-center")) {
        document.querySelector("#main").classList.remove("v-center");
      }
      if (this.$store.getters.currentOrder.personalMix.length > 0) {
        this.$store.commit("saveHash");
      }
    },
    outOfView() {
      document.querySelector("#main").classList.add("v-center");
    },
    removeIng(orderId, name) {
      let result = confirm(this.textConfirm);
      if (result) {
        this.$store.commit("removeIng", { orderId: orderId, name: name });
      }
    },
    removeUpselling(productIdWithIndex) {
      let result = confirm(this.textConfirmUpselling);
      if (result) {
        this.$store.commit("removeUpselling", productIdWithIndex);
      }
    },
    addNewOrder() {
      this.$store.commit("newOrder");
      this.$store.commit("firstStep");
    },
    orderPrice(personalMix) {
      return calc.orderPrice(
        personalMix,
        this.$store.getters.currency,
        this.$store.getters.subscriptionOptions
      );
    },
    totalPrice() {
      let price = 0;
      for (let order of this.$store.getters.orders) {
        price += this.orderPrice(order.personalMix);
      }
      // add upselling products
      for (let upsellingOrder of this.$store.getters.upsellingOrders) {
        if (upsellingOrder.min_variant_price) {
          price += upsellingOrder.min_variant_price;
        }
      }
      return price;
    },
    displayPrice() {
      return this.$store.getters.monthly
        ? Number(this.monthlyPrice())
        : this.totalPrice();
    },
    replaceTextLastxDays(personalMix) {
      let days =
        personalMix === this.$store.getters.personalMix
          ? this.$store.getters.lastXDays
          : calc.lastXDays(personalMix);
      let outputString = "";
      if (days <= 1) {
        outputString = this.summary_page_day;
      } else {
        outputString = days + " " + this.summary_page_days;
      }
      return this.textLastXDays.replace("[#VALUE#]", outputString);
    },
    days() {
      return this.$store.getters.lastXDays;
    },
    ratePrice() {
      return getInstallmentsCount(this.days());
    },
    monthlyPrice() {
      return (this.totalPrice() / this.ratePrice()).toFixed(2);
    },
    everyXMonths() {
      return Number(this.ratePrice());
    },
    replaceIngredientCount(personalMix) {
      let count = personalMix.length;
      let outputString = "";
      if (count <= 1) {
        outputString = this.summary_page_ingredient;
      } else {
        outputString = count + " " + this.summary_page_ingredients;
      }
      return this.textIngredientCount.replace("[#VALUE#]", outputString);
    },
    capsuleRecommendationText() {
      const order = this.$store.getters.currentOrder;

      if (order.intakeRecommendationMin && order.intakeRecommendationMax) {
        return `${order.intakeRecommendationMin}-${order.intakeRecommendationMax} ${this.summary_page_capsules}`;
      }

      return order.intakeRecommendation;
    },
    replaceCapsuleCount(personalMix) {
      if (personalMix === this.$store.getters.personalMix) {
        const recommendationText = this.capsuleRecommendationText();

        if (recommendationText) {
          return this.textXCapsule.replace("[#VALUE#]", recommendationText);
        }
      }

      let totalCapsulas =
        personalMix === this.$store.getters.personalMix
          ? this.$store.getters.totalCapsulas
          : calc.totalCapsulas(personalMix);
      let outputString = "";
      if (totalCapsulas <= 1) {
        outputString = " " + this.summary_page_capsule;
      } else {
        outputString = totalCapsulas + " " + this.summary_page_capsules;
      }
      return this.textXCapsule.replace("[#VALUE#]", outputString);
    },
    replaceTextPayPerDay(personalMix) {
      let totalCapsulas =
        personalMix === this.$store.getters.personalMix
          ? this.$store.getters.totalCapsulas
          : calc.totalCapsulas(personalMix);
      let pricePerDay = parseFloat(
        calc.orderPrice(
          personalMix,
          this.$store.getters.currency,
          this.$store.getters.subscriptionOptions
        ) /
          (calc.capsulasPerMixForCalculation() / totalCapsulas)
      );
      return this.textPayPerDay
        .replace("[#VALUE#]", pricePerDay.toFixed(2))
        .replace("[#CURRENCY#]", this.$store.getters.currencySymbol);
    },
    getIngredientsString(personalMix) {
      let text = [];
      for (let ing of personalMix) {
        text.push(ing.ingredientName);
      }
      return text.join(", ");
    },
    toggleVisibility1(mix) {
      if (mix.isVisible) {
        mix.isVisible = false;
      } else {
        mix.isVisible = true;
      }
    },
    toggleVisibility2(order) {
      if (order.isVisible) {
        order.isVisible = false;
      } else {
        order.isVisible = true;
      }
    },
    toggleVisibility3(reciept) {
      if (reciept.isVisible) {
        reciept.isVisible = false;
      } else {
        reciept.isVisible = true;
      }
    },
    toggleVisibility4(abo) {
      if (abo.isVisible) {
        abo.isVisible = false;
      } else {
        abo.isVisible = true;
      }
    },
    prevStep() {
      this.$store.commit("prevStep");
    },
    handleEditMix() {
      const oldUrl = location.href;
      const url = new URL(oldUrl);
      url.hostname = this.$store.getters.branding.subdomainExpertMode;
      window.parent.location = url.href;
    },
    hideEmailOverlay() {
      this.showEmailOverlay = false;
      this.emailEntered = false;
    },
    showBloodTestOption() {
      return false;
    },
  },
  mounted() {
    if (localStorage.getItem("debugMode")) {
      // Debug: Upselling debugging mode
      setTimeout(() => {
        this.$store.dispatch("getProducts");
        this.$store.commit("filterUpsellingProducts");
      }, 500);
    }
  },
  updated() {
    if (this.$store.getters.scene == this.scene) {
      this.inView();
    } else {
      this.outOfView();
    }
  },
  components: {
    IngredientsList,
    // ProductHighlights,
    IndividualSupplement,
    InfoLayer,
    WarningSign,
    CapsulaInfo,
    // SuggestedProducts,
    // InputField,
    Accordion,
    CheckoutButton,
    DetailsPictures,
    RatingStars,
    RecieptsCount,
  },
};
</script>

<style scoped>
.bullet-item {
  display: flex;
  align-items: flex-start;
}

.bullet {
  margin-right: 10px;
}

.bullet-item p {
  margin: 0;
}
.order-text {
  font-size: 16px;
  color: black;
}

.order-text2 {
  font-size: 16px;
  color: black;
  margin-bottom: 10px;
  margin-top: 5px;
}

.info-icon {
  width: 20px;
  height: 20px;
  cursor: pointer;
  margin-left: 5px;
}

h2 {
  margin-block-start: 0 !important;
  margin-block-end: 0 !important;
}

p {
  margin-block-start: 0 !important;
  margin-block-end: 0 !important;
  margin-bottom: 15px !important;
}

@media only screen and (min-width: 815px) {
  #sticky {
    position: sticky;
    position: -webkit-sticky;
    top: 100px;
    height: 100px;
    display: flex;
    flex-direction: column;
  }
}

.picture-test {
  width: 30px;
  height: 30px;
}

.picture-div {
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.checkbox-group {
  display: flex;
  align-items: start;
}

.payment-details-label {
  font-size: 16px;
  margin-top: 10px;
}

.payment-details-text {
  font-size: 16px;
  margin-top: 10px;
}

.reorder-buttons-group {
  margin-bottom: 10px;
}

.reorder-details-text {
  font-size: 16px;
  margin-top: 0;
  margin-bottom: 18px;
}

.buttons-group {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;
  /* white-space: nowrap; */
}
.checkbox-blood-test {
  margin-right: 10px;
  width: 20px;
  height: 20px;
}

.btn-discount {
  text-transform: none !important;
}

.btn-active {
  padding: 0 20px;
  background: #000;
  color: #fff;
  border-radius: 999px;
  border: none;
  text-transform: uppercase;
  font-size: 17px;
  cursor: pointer;
  white-space: nowrap;
  min-height: 35px;
  min-width: fit-content;
  padding-left: 20px;
  padding-right: 20px;
}

.btn-inactive {
  height: 35px;
  width: 110px;
  background: #fff;
  color: #000;
  border-radius: 999px;
  border: solid 1px #000;
  text-transform: uppercase;
  font-size: 17px;
  cursor: pointer;
  flex: 1;
  white-space: nowrap;
  min-width: fit-content;
  padding-left: 20px;
  padding-right: 20px;
}

.payment-options {
  display: flex;
  flex-direction: column; /* Vertikale Anordnung der Elemente */
  align-items: start; /* Zentriert alle Elemente horizontal */
  color: #000;
}

.payment-options-header {
  font-size: 20px;
  padding: 0 0;
}

hr {
  margin-left: -100%;
  margin-right: -100%;
}

.product-header {
  margin-left: -300px;
  margin-right: -300px;
  padding-left: 300px;
  padding-right: 300px;
  justify-content: center;
  margin-top: 80px;
}

.recommend-header-container {
  display: flex;
  align-items: center;
  padding: 80px 0px 0px 0px;
}

.recommend-headline {
  font-size: 20px;
  text-transform: uppercase;
}

.recommend-header-text {
  max-width: 600px;
  background-color: #fff;
  box-shadow: 0px 0px 10px #b9b9b9;
  border-radius: 10px;
  padding: 40px;
  border: 0px;
}

@media only screen and (max-width: 815px) {
  .recommend-header-container {
    padding-top: 10px;
  }

  .recommend-header-text {
    text-align: center;
    box-shadow: none;
  }

  #checkoutButtonMobile {
    margin: 10px auto;
    width: 200px;
  }
}
.container-1440 {
  text-align: start;
}
@media only screen and (min-width: 815px) {
  .container-1440 {
    margin-bottom: 4rem;
  }

  .footer-fixed {
    display: flex;
    align-items: center;
    justify-content: end;
    padding: 20px 0;
    box-shadow: 0px -5px 10px #b9b9b9;
  }

  #checkoutButtonMobile {
    width: 300px;
    margin-right: 5%;
  }
}

.username {
  font-size: 80px;
  line-height: 120%;
}

.textblock {
  font-size: 20px;
}

.month {
  margin-top: 10px;
  font-size: 25px;
  font-weight: bold;
}

.button-header-checkout {
  min-width: 100px !important;
}

@media only screen and (max-width: 815px) {
  .username {
    font-size: 60px;
  }

  .recommend-headline {
    font-size: 13px;
  }

  .recommend-header-text {
    padding: 20px 0px;
  }

  .textblock {
    font-size: 13px;
  }

  .month {
    font-size: 18px;
  }
}

/*  */

.dark-header {
  position: absolute;
  height: 700px;
  min-height: 400px;
  width: 100vw;
  left: calc(-50vw + 50%);
  overflow: hidden;
  background-color: #683af2;
  z-index: -1;
}

@media only screen and (max-width: 815px) {
  .summary {
    padding-bottom: 3rem;
  }
}

.summary-headline {
  max-width: 800px;
  font-size: 44px;
  padding-top: 350px;
}

@media only screen and (max-width: 815px) {
  .summary-headline {
    font-size: 34px;
  }
}

/* .scroll-container {
  overflow-y: auto;
  position: absolute;
  height: calc(100% - 50px);
}

@media only screen and (max-width: 815px) {
  .scroll-container {
    position: relative;
    overflow-y: initial;
  }
} */

.top-spacer {
  margin-top: 120px;
}

.margin-top {
  margin-top: 15px;
}

.big-name {
  font-size: 44px;
  font-family: "Groteska Medium";
}

.summary-headline-subline {
  display: none;
}

.order-header {
  margin-top: 30px;
  margin-bottom: 15px;
  display: inline-flex;
  align-items: center;
  width: 100%;
  justify-content: flex-end;
}

@media only screen and (max-width: 815px) {
  .order-header {
    border-bottom: 1px solid #ccc;
  }
}

.mix-headline {
  flex: 1;
  font-size: 20px;
  color: #000;
  /* line-height: 30px; */
}

.order-toggle {
  margin-left: 20px;
}

.order-content {
  font-size: 15px;
  margin-bottom: 20px;
  line-height: 120%;
}

.warning-sign {
  position: absolute;
  right: 30px;
  top: 12px;
  width: 16px;
  height: 16px;
}

.subline {
  color: #fff;
  font-size: 20px;
  margin-top: 50px;
}

.container-summary {
  position: relative;
}

.email-overlay {
  position: fixed;
  z-index: 50;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
}

.email-overlay .question-box {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  background-color: white;
  border-radius: 1rem;
  width: 60%;
}

.email-overlay .email-entered {
  padding: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  flex-direction: column;
  gap: 1rem;
}

@media only screen and (max-width: 1440px) {
  .email-overlay .question-box {
    width: 75%;
  }
}

@media only screen and (max-width: 815px) {
  .email-overlay .question-box {
    width: 90%;
  }
}

.container-summary .subline {
  max-width: 500px;
}

.summary-container-headline {
  color: #683af2;
}

.border-bottom {
  border-bottom: 1px solid #ccc;
}

.border-bottom-big {
  border-bottom: 2px solid #ccc;
}

.border-right {
  border-right: 1px solid #ccc;
}

.margin-left {
  margin-left: 10px;
}

.buy-button-info {
  display: inline-block;
  font-size: 13px;
}

.total-price {
  background-color: var(--ci-color-1);
  padding: 15px 28px 15px 28px;
  font-size: 25px;
  color: white;
}

.float-right {
  float: right;
  font-weight: 600;
}

.edit-mix {
  cursor: pointer;
  text-decoration: underline;
  font-style: italic;
  font-weight: bold;
}

@media only screen and (max-width: 815px) {
  .float-right {
    margin-right: 12px;
  }

  tr:last-child td:last-child {
    min-width: 70px;
  }
}

.pills-white-background {
  background-image: url("../../public/assets/pills-right-white.svg");
  background-repeat: no-repeat;
  background-position: right top;
  background-size: 130%;
  height: 100%;
}

@media only screen and (min-width: 815px) {
  .pills-white-background {
    background-image: url("../../public/assets/pills-right-white.svg");
    background-repeat: no-repeat;
    background-position: right top;
    background-size: contain;
    height: 100%;
    background-size: 100%;
  }
}

.header {
  position: absolute;
  padding: 20px;
}

.header-space {
  padding-top: 700px;
}

@media only screen and (max-width: 815px) {
  .header-space {
    padding-top: 100px;
  }
}

table {
  width: 100%;
  border-collapse: collapse;
}

tr {
  text-align: left;
}

td {
  position: relative;
}

@media only screen and (max-width: 1070px) {
  .ing-text {
    font-size: 12px;
  }

  td {
    font-size: 12px;
  }

  td:first-child {
    padding-right: 30px;
  }
}

@media only screen and (max-width: 815px) {
  table {
    width: calc(100% + 10px);
  }
}

.more-space {
  padding: 60px 10px 20px 70px;
}

.top-space {
  padding-top: 80px;
}

@media (max-width: 815px) {
  .top-space {
    padding-top: 0px;
  }

  .more-space {
    padding: 0px 0px 0px 0px;
  }

  .more-space p:last-child {
    font-size: 13px;
  }
}

.spacer {
  padding-top: 20px;
}

@media only screen and (min-width: 815px) {
  .button-white {
    background-color: #fff;
    color: var(--ci-color-1);
    border: 1px solid black;
  }
}

@media only screen and (max-width: 815px) {
  #addAnotherButton {
    margin: 10px auto;
  }

  #checkoutButtonMobile {
    margin: 10px auto;
    width: 200px;
  }
}

@media only screen and (min-width: 815px) {
  .container-1440 {
    margin-bottom: 6rem;
  }

  .footer-fixed {
    display: flex;
    align-items: center;
    justify-content: end;
    padding: 20px 0;
    box-shadow: 0px -5px 10px #b9b9b9;
  }

  #checkoutButtonMobile {
    width: 300px;
    margin-right: 5%;
  }
}

.button-header-checkout {
  min-width: 100px !important;
}

hr {
  background-color: #707070;
  border: none;
  height: 1px;
  margin-top: 15px;
}

.font-size-20 {
  font-size: 20px;
}

.text-center {
  text-align: center;
}

.text-right {
  text-align: right;
}

.padding-top-bottom {
  padding-top: 10px;
  padding-bottom: 10px;
}

.padding-bottom {
  padding-bottom: 10px;
}
</style>
